// country-rules-view.js — reine Aufbereitung der Länderregeln (country-rules.js) für die Anzeige.
// Keine Texte hier: die Funktionen liefern Schlüssel und Werte, übersetzt wird in der Oberfläche (i18n `rules`).
import { RULES, ROADS, CLASSES } from './country-rules.js';

export { ROADS, CLASSES };

/** Regeln eines Landes (ISO-Code) oder null. */
export function rulesFor(iso) {
  return iso && Object.prototype.hasOwnProperty.call(RULES, iso) ? RULES[iso] : null;
}

/**
 * Fahrzeugklasse für die Regeln: Wohnwagen-Vorlage → Gespann, über 3,5 t → Wohnmobil über 3,5 t, sonst Pkw/Wohnmobil
 * bis 3,5 t. Bewusst NICHT gradeLimit(): das stuft jede Wohnmobil-Vorlage als schwer ein, auch unter 3,5 t.
 */
export function ruleClass({ preset, weight } = {}) {
  if (typeof preset === 'string' && preset.startsWith('ww-')) return 'trailer';
  const w = parseFloat(String(weight ?? '').replace(',', '.'));
  if (Number.isFinite(w) && w > 3.5) return 'rv';
  return 'car';
}

/** Eine Tempo-Zelle: { kind: 'kmh'|'none'|'signed'|'unknown', value } */
export function speedCell(v) {
  if (typeof v === 'number' && v > 0) return { kind: 'kmh', value: v };
  if (v === 'none') return { kind: 'none' };
  if (v === 'signed') return { kind: 'signed' };
  return { kind: 'unknown' };
}

/** Tempozeile einer Klasse: [{ road, kind, value }] in der Reihenfolge innerorts … Autobahn. */
export function speedRow(rules, cls) {
  const row = (rules && rules.speed && rules.speed[cls]) || [];
  return ROADS.map((road, i) => ({ road, ...speedCell(row[i]) }));
}

/** Bußgeld als { kind: 'exact'|'from'|'range'|'unknown', a, b, currency } */
export function fineView(f, currency) {
  if (!f || !(f.min > 0)) return { kind: 'unknown' };
  if (f.max > f.min) return { kind: 'range', a: f.min, b: f.max, currency };
  return { kind: f.from ? 'from' : 'exact', a: f.min, currency };
}

/** Mautsystem je Gewichtsklasse: { car, heavy, url } mit bekannten Schlüsseln. */
export const TOLL_SYSTEMS = ['vignette', 'distance', 'mixed', 'none', 'flat', 'bridges'];
export function tollView(rules) {
  const t = (rules && rules.toll) || {};
  const ok = (s) => (TOLL_SYSTEMS.includes(s) ? s : null);
  return { car: ok(t.car), heavy: ok(t.heavy), url: /^https:\/\//.test(t.url || '') ? t.url : null };
}

/** Host einer Quelle für die Anzeige. */
export function sourceHost(u) {
  try { return new URL(u).hostname.replace(/^www\./, ''); } catch { return null; }
}
